export default __webpack_public_path__ + "static/media/paul2.ee22af60.jpg";